import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

export const RightSidebarSlotContext = createContext<HTMLElement | null | undefined>(undefined);

export const RightSidebarSlot = ({ children }: { children: ReactNode }) => {
  const slot = useContext(RightSidebarSlotContext);
  if (slot === undefined) return <>{children}</>;
  return slot ? createPortal(children, slot) : null;
};
